import { render, staticRenderFns } from "./TopicCard.vue?vue&type=template&id=494a8888&scoped=true&"
import script from "./TopicCard.vue?vue&type=script&lang=js&"
export * from "./TopicCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "494a8888",
  null
  
)

export default component.exports